<template>
  <v-simple-table
    class="table-layout border-table table-contact table-filter-contact"
    style="border: 0;"
  >
    <template v-slot:default>
      <thead>
        <tr>
          <th
            class="font-weight-regular --module-title"
            rowspan="2"
            @click="clickFilterModule('all')"
            :class="isActive == 'all' ? 'active' : ''"
          >Tất cả</th>
          <template v-for="(module, index) in typeHeaderContactModule">
            <th
              @click="clickFilterModule(module)"
              :rowspan="module.code ? 2 : null"
              class="font-weight-regular --module-title"
              :key="'type-' + index"
              :colspan="module.colspan"
            >
              {{ module.name }}
            </th>
          </template>
        </tr>
        <tr class="tr-contact-status">
          <template v-for="(itemModule, index) in contactModuleList">
          <th
            @click="clickFilterModule(itemModule)"
            class="font-weight-regular"
            :key="'name-type-' + index"
            :class="isActive == `${itemModule.typeId}_${itemModule.schoolLevelId}_${itemModule.code}` ? 'active' : ''"
            v-if="!colsNotIn.includes(itemModule.code)"
          >
            {{ itemModule.name }}
          </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="min-width: 5rem;" :class="isActive == 'all' ? 'active total-number' : 'total-number'">{{ totalContactModule }}</td>
          <td
            v-for="(itemModule, index) in contactModuleList"
            :key="'noContactModule-' + index"
            :class="isActive == `${itemModule.typeId}_${itemModule.schoolLevelId}_${itemModule.code}` ? 'active' : ''"
          >
            {{itemModule.noContact}}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  props: {
    filterForm: {
      type: Object,
      default: () => ({})
    },
    totalContactModule: {
      type: Number,
      default: 0
    },
    typeHeaderContactModule: {
      type: Array,
      default: () => []
    },
    contactModuleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isActive: 'all',
      colsNotIn: ['SL', 'SP','SĐL']
    };
  },
  methods: {
    clickFilterModule(item) {
      this.filterForm.contactAgency = item.code == 'SĐL' ? true : null
      if(item == 'all'){
        this.filterForm.soLoi = null;
        this.filterForm.isMainId = null;
        this.filterForm.typeId = null;
        this.filterForm.schoolLevelId = null;
        Bus.$emit('contact-list-filter', this.filterForm);
        this.isActive = 'all';
      }
      else {
        this.filterForm.typeId = item.typeId;
        this.filterForm.schoolLevelId = item.schoolLevelId;
        this.filterForm.soLoi = item.code == 'SL' ? true : null;
        this.filterForm.isMainId = item.code == 'SP' ? 1 : item.code == 'SL' ? 0 : null;
        Bus.$emit('contact-list-filter-by-contact-status', this.filterForm);
        this.isActive = `${item.typeId}_${item.schoolLevelId}_${item.code}`;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .active {
    font-weight: bold!important;
    font-size: 14px!important;
    font-weight: bold;
  }
  .font-weight-regular {
    border-bottom: thin solid rgba(0, 0, 0, 0.12); cursor: pointer
  }
  .--module-title {
    font-weight: bold !important;
    font-size: 16px !important;
    text-transform: uppercase;
    background: #ECEBF3;
  }
  .total-number {
    color: #411BAE;
  }
  .table-filter-contact {
    th {
      border-right: 1px solid #d2d2d2;
      height: 30px;
      &:last-child {
        border-right: thin solid rgba(0, 0, 0, 0.12);
      }
      td {
        position: relative;
        border-right: 1px solid #d2d2d2;
        &:last-child {
          border-right: 0;
        }
      }
    }
    td {
      padding-top: 0;
      padding-bottom: 0;
      height: 30px;
    }
    thead tr {
      height: 30px;
      th {
        color: #000000;
        min-width: 65px !important;
      }
    }
    tbody {
      tr {
        height: 30px;
      }
    }
  }
</style>
